module.exports = __webpack_public_path__ + "img/SES_TailWing_Profiles.f5ab9277.jpg";